module.exports = __webpack_public_path__ + "static/media/clubs_J.f53094a7.png";